/* eslint-disable camelcase */
import React, { Fragment, useState } from "react";
import moment from "moment";
import { string } from "prop-types";
import Spinner from "../../common/Spinner";
import PayslipsContainer from "../../containers/Payslips";
import * as style from "./styles.module.scss";
import history from "../../history";

const DownloadButton = ({ label, href }) => {
  const [loading, setLoading] = useState(false);

  const triggerDownload = async (e) => {
    e.preventDefault();
    setLoading(true);
    let filename = "";
    fetch(e.target.getAttribute("href"))
      .then((res) => {
        const header = res.headers.get("Content-Disposition");
        const parts = header.split(";");
        filename = parts[1].split("=")[1]; // eslint-disable-line prefer-destructuring
        return res.blob();
      })
      .then((pdfBlob) => {
        const link = document.createElement("a");
        const objectURL = URL.createObjectURL(pdfBlob);
        link.href = objectURL;
        link.download = filename;
        link.click();
        setLoading(false);
      });
  };

  return (
    <button
      className="btn btn-primary d-block"
      href={href}
      onClick={(e) => triggerDownload(e)}
      disabled={loading ? "disabled" : ""}
    >
      {loading ? (
        <Fragment>
          {label} <Spinner />
        </Fragment>
      ) : (
        <Fragment>{label}</Fragment>
      )}
    </button>
  );
};

DownloadButton.propTypes = {
  href: string.isRequired,
  label: string.isRequired,
};

const Payslips = () => {
  const [content, showContent] = useState("");

  const isCurrentYear = (year) => year === moment().year().toString();
  return (
    <div>
      <PayslipsContainer>
        {({
          payslips,
          hasP45,
          hasP60_2022,
          hasP60_2023,
          hasP60_2024,
          hasP60_2025,
        }) => {
          const payslipsInFolders =
            payslips &&
            payslips
              .map((el) => ({ ...el, folder_year: el.pay_date.split("/")[2] }))
              .reduce((acc, x) => {
                return {
                  ...acc,
                  [x.folder_year]: [...(acc[x.folder_year] ?? []), x],
                };
              }, {});
          return (
            <Fragment style={{ maxWidth: "700px" }}>
              <div
                style={{ paddingTop: "20px", paddingBottom: "20px" }}
                className="container"
              >
                {(hasP45 ||
                  hasP60_2022 ||
                  hasP60_2023 ||
                  hasP60_2024 ||
                  hasP60_2025) && (
                  <div className="row">
                    {hasP45 && (
                      <div className="col-md-3">
                        <h2
                          id="timesheetsHeader"
                          className={`${style.timesheets_header} py-2`}
                          style={{ marginBottom: "0" }}
                        >
                          Your P45
                        </h2>

                        <div style={{ marginBottom: "4rem" }}>
                          <DownloadButton
                            href={`/api/payroll/p45`}
                            label="Download P45"
                          />
                        </div>
                      </div>
                    )}
                    {(hasP60_2022 ||
                      hasP60_2023 ||
                      hasP60_2024 ||
                      hasP60_2025) && (
                      <div className="col-md-6">
                        <h2
                          id="timesheetsHeader"
                          className={`${style.timesheets_header} py-2`}
                          style={{ marginBottom: "0" }}
                        >
                          Your P60
                        </h2>

                        {hasP60_2022 && (
                          <div
                            style={{
                              marginBottom: "2rem",
                              display: "inline-block",
                              marginRight: "1rem",
                            }}
                          >
                            <DownloadButton
                              href={`/api/payroll/p60/2022`}
                              label="Download 2021-2022 P60"
                            />
                          </div>
                        )}

                        {hasP60_2023 && (
                          <div
                            style={{
                              marginBottom: "2rem",
                              display: "inline-block",
                            }}
                          >
                            <DownloadButton
                              href={`/api/payroll/p60/2023`}
                              label="Download 2022-2023 P60"
                            />
                          </div>
                        )}

                        {hasP60_2024 && (
                          <div
                            style={{
                              marginBottom: "2rem",
                              display: "inline-block",
                            }}
                          >
                            <DownloadButton
                              href={`/api/payroll/p60/2024`}
                              label="Download 2023-2024 P60"
                            />
                          </div>
                        )}

                        {hasP60_2025 && (
                          <div
                            style={{
                              marginBottom: "2rem",
                              display: "inline-block",
                            }}
                          >
                            <DownloadButton
                              href={`/api/payroll/p60/2025`}
                              label="Download 2024-2025 P60"
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
                <div>
                  <h2
                    id="timesheetsHeader"
                    className={style.timesheets_header}
                    style={{ display: "inline-block" }}
                  >
                    Your Payslips
                  </h2>
                  <a
                    href="https://www.hrgo.co.uk/media/7536/payroll_faqs.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-secondary"
                    style={{ float: "right" }}
                  >
                    Pay FAQs
                  </a>
                  <div>
                    <div
                      className={`bg-white ${style.profile__snackbar} d-flex justify-content-between mb-2`}
                    >
                      <span className="d-flex">
                        <div className="pr-1"></div>
                        <div>
                          <span className={style.profile__snackbar_description}>
                            We are sure you have heard that National Minimum
                            Wage (NMW) is increasing from 1st April 2024, so why
                            might your pay not increase until 19th April 2024 -
                            let us explain so there are no surprises when you
                            receive your pay this week or next.
                          </span>
                          <br />
                          <span className={style.profile__snackbar_description}>
                            The increase in NMW is effective from the first `pay
                            reference period` on or after 1st April. Our payroll
                            week runs from Sunday to Saturday, so the increase
                            is effective for the period from 7th April to 13th
                            April, payable on 19th April.
                          </span>
                          <br />
                          <div className={style.profile__snackbar_description}>
                            <span>
                              For further advice and examples you can visit
                            </span>
                            <a
                              href="https://www.acas.org.uk/national-minimum-wage-entitlement"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              When increases are paid - National Minimum Wage -
                              Acas
                            </a>
                          </div>
                        </div>
                      </span>
                    </div>
                    {!payslipsInFolders ||
                      (Object.keys(payslipsInFolders).length === 0 && (
                        <div>
                          <p>You currently don’t have a payslip to view yet.</p>
                          <p>All payslips are available from 5pm Thursday.</p>
                          <p>
                            For any payslip or P45 queries or issues, please
                            contact our Customer Success team, Monday - Friday
                            between 9am - 5pm on 01233 515169 or via email at{" "}
                            <a href="mailto:customer.success@hrgo.co.uk">
                              customer.success@hrgo.co.uk
                            </a>
                          </p>
                        </div>
                      ))}
                    {payslipsInFolders &&
                      Object.keys(payslipsInFolders).length > 0 && (
                        <Fragment>
                          {Object.keys(payslipsInFolders)
                            .sort((a, b) => b - a)
                            .map((el, i) => (
                              <Fragment key={i}>
                                <div
                                  style={{
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    fontSize: "30px",
                                    border: `${
                                      !isCurrentYear(el) && "2px solid black"
                                    }`,
                                    padding: "10px",
                                    borderRadius: "10px",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    display: "flex",
                                    margin: "5px 0",
                                  }}
                                  className="styles__onboarding__wrapper___3a5Dz items-center flex-row mb6-0"
                                  onClick={() => {
                                    if (!isCurrentYear(el)) {
                                      showContent(content === el ? "" : el);
                                    }
                                    return null;
                                  }}
                                >
                                  {el} Payslips
                                  {!isCurrentYear(el) && (
                                    <img
                                      style={{ marginLeft: "22px" }}
                                      src="https://www.hrgo.co.uk/images/nav/nav-arrow-down.svg"
                                      className={`${
                                        content === el && style.rotateimg180
                                      }`}
                                      width="15px"
                                      height="15px"
                                    />
                                  )}
                                </div>
                                {(content === el || isCurrentYear(el)) && (
                                  <Fragment>
                                    <table
                                      className={`table d-none d-md-table`}
                                    >
                                      <thead>
                                        <tr>
                                          <th>Pay Date</th>
                                          <th>View</th>
                                          <th>Download</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {payslipsInFolders[el].map((ps) => {
                                          const {
                                            pay_date,
                                            Tax_Period,
                                            tax_year,
                                          } = ps;
                                          return (
                                            <tr key={Tax_Period}>
                                              <td>{pay_date}</td>
                                              <td>
                                                <a
                                                  className="btn btn-primary"
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  href={`/api/payroll/payslips/${tax_year}/${Tax_Period}`}
                                                >
                                                  View payslip
                                                </a>
                                              </td>
                                              <td>
                                                <DownloadButton
                                                  label="Download payslip"
                                                  href={`/api/payroll/payslips/${tax_year}/${Tax_Period}/pdf`}
                                                />
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                    <div className="d-block d-md-none">
                                      {payslipsInFolders[el].map((ps) => {
                                        const {
                                          pay_date,
                                          Tax_Period,
                                          tax_year,
                                        } = ps;
                                        return (
                                          <div
                                            className="card"
                                            style={{ padding: "5px" }}
                                            key={Tax_Period}
                                          >
                                            <div className="card-body">
                                              <h5 className="card-title">
                                                Pay Date: {pay_date}
                                              </h5>
                                              <a
                                                className="btn btn-primary card-link d-inline-block mb-1"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={`/api/payroll/payslips/${tax_year}/${Tax_Period}`}
                                              >
                                                View payslip
                                              </a>
                                              <DownloadButton
                                                label="Download payslip"
                                                href={`/api/payroll/payslips/${tax_year}/${Tax_Period}/pdf`}
                                              />
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </Fragment>
                                )}
                              </Fragment>
                            ))}
                          <p className="my-2">
                            For any payslip or P45 queries or issues, please
                            contact our Customer Success team, Monday - Friday
                            between 9am - 5pm on 01233 515169 or via email at{" "}
                            <a href="mailto:customer.success@hrgo.co.uk">
                              customer.success@hrgo.co.uk
                            </a>
                          </p>
                        </Fragment>
                      )}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    padding: "30px 0",
                    justifyContent: "space-between",
                  }}
                >
                  <button
                    onClick={() => history.push("/profile")}
                    style={{ backgroundColor: "lightgray" }}
                    className="btn"
                  >
                    Back to My Account
                  </button>
                </div>
              </div>
            </Fragment>
          );
        }}
      </PayslipsContainer>
    </div>
  );
};

export default Payslips;
